"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var opacityMap = {
    weak: 0,
    medium: 1,
    strong: 2,
};
exports.default = (function (_a) {
    var opacityLevels = _a.theme.opacity, opacity = _a.opacity;
    var value = opacity && opacityLevels[opacityMap[opacity]];
    return value ? "opacity: " + value + ";" : '';
});
